import { BackgroundDots } from "@msuite/ui/background";
import { Button } from "@msuite/ui/button";
import { AuthForm, TextInput } from "@msuite/ui/form";
import { resolver } from "@msuite/ui/libs/form";
import { useTranslation } from "@msuite/ui/localization";
import { toast } from "@msuite/ui/toast";
import { type UserForgotPasswordForm, userForgotPasswordSchema } from "@msuite/utils/schemas";
import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import { authClient } from "@/api/auth";
import { LegalFooter } from "@/components/legal-footer";

export function ForgotPassword() {
	/** Hooks */
	const navigate = useNavigate();
	const { t } = useTranslation();
	const methods = useForm({
		resolver: resolver(userForgotPasswordSchema),
	});

	/** Functions */
	function handleOnNavigateBack() {
		navigate(-1);
	}

	async function handleOnSubmit(json: UserForgotPasswordForm) {
		await authClient.requestPasswordReset({
			email: json.email,
		});
		toast.success(t("auth.password_reset_link_sent"));
	}

	/** Render */
	return (
		<React.Fragment>
			<BackgroundDots />
			<div className="flex-center w-screen h-screen">
				<AuthForm onSubmit={methods.handleSubmit(handleOnSubmit)}>
					<AuthForm.Header />
					<AuthForm.Body>
						<TextInput
							className="input"
							control={methods.control}
							name="email"
							label={t("personnel.fields.email")}
							placeholder={t("placeholders.email")}
							isRequired
						/>
					</AuthForm.Body>
					<AuthForm.Footer>
						<Button
							type="submit"
							variant="primary"
							size="sm"
							isLoading={methods.formState.isSubmitting}
						>
							{t("auth.get_password_reset_link")}
						</Button>
						<Button
							size="sm"
							variant="ghost"
							onClick={handleOnNavigateBack}
						>
							{t("general.cancel")}
						</Button>
					</AuthForm.Footer>
				</AuthForm>
			</div>
			<LegalFooter />
		</React.Fragment>
	);
}
